import React, { useEffect, useState } from 'react'
import { Checkbox } from 'antd'
import './style.scss'
import useRouter from 'hooks/useRouter'
import { useAppSelector } from 'hooks/useRedux'
import { listInvoiceFromPosQueries } from 'features/Invoice/screens/ListInvoiceFromPOS/queries'
import { useQuery } from '@tanstack/react-query'
import useFilter from 'hooks/useFilter'

function getCurrentTime() {
  const now = new Date()
  return now.toLocaleTimeString('vi-VN', {
    hour: '2-digit',
    minute: '2-digit',
  })
}

export default function TaxNotify() {
  const today = new Date().toISOString().slice(0, 10)

  const [visible, setVisible] = useState(false)
  const [dontShowToday, setDontShowToday] = useState(false)
  const [currentTime, setCurrentTime] = useState(getCurrentTime())
  const { company } = useAppSelector((state) => state.system)

  const { navigate } = useRouter()
  const sysType = useAppSelector((state) => state.auth.activeInvoice)

  const STORAGE_KEY = `TAX_NOTIFY_HIDE_DATE_${company?.companyId}`

  const [filterParams] = useFilter(
    'listInvoiceFromPOS',
    'gFilterListInvoiceFromPOS',
  )

  const { data: queryData, refetch } = useQuery(
    listInvoiceFromPosQueries.listInvoiceMttNeedSendTax({
      ...filterParams,
      viewSendCQT: 1,
      notify: 1,
    }),
  )

  useEffect(() => {
    const hideDate = localStorage.getItem(STORAGE_KEY)
    if (
      hideDate !== today &&
      company?.companyId &&
      queryData &&
      ((sysType?.invoice && queryData?.invoices?.length >= 1) ||
        (sysType?.ticket && queryData?.tickets?.length >= 1))
    ) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }, [today, queryData, sysType, company])

  useEffect(() => {
    if (!visible) return

    const timer = setInterval(() => {
      setCurrentTime(getCurrentTime())
    }, 60 * 1000)

    return () => clearInterval(timer)
  }, [visible])

  const handleClose = () => {
    if (dontShowToday) {
      localStorage.setItem(STORAGE_KEY, today)
    }
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="tax-notify-mask show">
      <div className="tax-notify">
        {/* header */}
        <div className="tax-header">
          <img
            className="tax-icon"
            src="https://cdn-icons-png.flaticon.com/512/1827/1827349.png"
            alt=""
          />
          <div className="tax-title">
            Gửi HĐ/Vé khởi tạo từ máy tính tiền đến CQT
          </div>
        </div>

        {/* content */}
        <div className="tax-content">
          <div className="tax-warning">
            Tính đến <b>{currentTime}</b>, tổng số HĐ/Vé cần gửi đến CQT là{' '}
            <span className="highlight">{queryData?.invoices?.length}</span>
          </div>

          <p>
            Theo quy định hiện hành: Người bán có trách nhiệm{' '}
            <b>
              chuyển dữ liệu hóa đơn điện tử có mã của cơ quan thuế khởi tạo từ
              máy tính tiền đến cơ quan thuế trong ngày
            </b>
            .
          </p>

          <p className="danger">
            Nếu sau thời gian quy định, đơn vị có thể bị phạt từ{' '}
            <b>2.000.000 đồng</b> đến <b>20.000.000 đồng</b>.
          </p>
        </div>

        {/* footer */}
        <div className="tax-footer">
          <Checkbox
            checked={dontShowToday}
            onChange={(e) => setDontShowToday(e.target.checked)}
          >
            Không hiển thị lại trong ngày
          </Checkbox>

          <div className="actions">
            <button className="btn-skip" onClick={handleClose}>
              Bỏ qua
            </button>
            <button
              className="btn-primary"
              onClick={() => {
                setVisible(false)
                if (sysType?.invoice) {
                  navigate(
                    '/hoa-don-dau-ra/hoa-don/may-tinh-tien/danh-sach-hoa-don?sendTax=1',
                  )
                } else if (sysType?.ticket) {
                  navigate(
                    '/hoa-don-dau-ra/tem-ve/ve-tu-may-tinh-tien/ve-da-xuat?sendTax=1',
                  )
                }
              }}
            >
              Gửi ngay
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
